'use client';

import { type Dispatch, type SetStateAction, useState } from 'react';

type UseStepperReturn = {
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  setStep: Dispatch<SetStateAction<number>>;
  step: number;
};

export const useStepper = (): UseStepperReturn => {
  const [step, setStep] = useState(1);

  const handleNextStep = () => {
    setStep((prev) => prev + 1);
  };

  const handlePreviousStep = () => {
    setStep((prev) => prev && prev - 1);
  };

  return {
    handleNextStep,
    handlePreviousStep,
    step,
    setStep,
  };
};
